"use client";
import { FieldErrors, UseFormRegister } from "react-hook-form";
import InputField from "../../../components/common/InputField";
import TextareaField from "../../../components/common/TextareaField";
import Input from "../../../components/Input";
import SelectInput from "../../../components/Select";
import { useWarehouseListData } from "../../../apis/warehouseApi";
import { useEffect, useState } from "react";
import TextArea from "../../../components/common/TextArea";

export const SystemTypes = [
  { value: "phone", text: "Phone" },
  { value: "email", text: "Email" },
  { value: "whatsapp", text: "WhatsApp" },
];

type FormValues = {
  id?: string;
  name: string;
  mobileNumber: string;
  email: string;
  warehouseId: string;
  city: string;
  shippingCost: string;
  address: string;
  clientType: string;
};

type Props = {
  register: UseFormRegister<FormValues>;
  errors: FieldErrors<FormValues>;
  clearErrors?: any;
  setValue?: any;
  watch?: any;
  getIds?: any;
  control?: any;
  merchantData?: any;
};

const AddClientCreateRequestModal = ({
  register,
  errors,
  clearErrors,
  setValue,
  control,
  getIds,
  watch,
  merchantData,
}: Props) => {
  const { data: warehouses } = useWarehouseListData();
  const [selectedData, setSelectedData] = useState<any>({
    warehouseId: "",
    city: "",
  });
  useEffect(() => {
    if (selectedData) {
      getIds(selectedData);
    }
  }, [selectedData]);
  return (
    <div className="w-full space-y-4 bg-[#faf8ec]">
      <div className="grid grid-cols-6 gap-4">
        <Input
          labelClass="text-sm text-[#1E293B]"
          name="name"
          type="text"
          title="Full Name / Business Name"
          placeholder=""
          className="col-span-6"
          register={register}
          error={errors?.name}
          validation={{
            required: "Name is required",
            validate: (value: string) => {
              const trimmed = value.trim();
              if (trimmed.length < 3)
                return "Name must be at least 3 characters";
              if (trimmed.length > 30)
                return "Name must be at most 30 characters";
              return true;
            },
          }}
        />
        <Input
          labelClass="text-sm text-[#1E293B]"
          name="mobileNumber"
          type="number"
          title="Mobile Number"
          placeholder=""
          register={register}
          className="col-span-3"
          error={errors?.mobileNumber}
          validation={{
            required: "Mobile number is required",
            // validate: (value: string) => {
            //   const trimmed = value.trim();
            //   if (trimmed.length !== 10)
            //     return "Mobile number must be 10 characters";
            //   return true;
            // },
          }}
        />
        <Input
          labelClass="text-sm text-[#1E293B]"
          name="email"
          type="text"
          title="Mail ID"
          placeholder=""
          className="col-span-3"
          register={register}
          error={errors?.email}
          validation={{
            required: "Email is required",
            setValueAs: (value: string) => value?.toLowerCase(),
            pattern: {
              value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
              message: "Please enter a valid email address",
            },
          }}
        />
        <SelectInput
          name="clientType"
          className="col-span-2"
          label="Select Client Type"
          placeholder="Select"
          selectOptions={
            [
              { id: "FM", name: "FM" },
              { id: "LM", name: "LM" },
              { id: "Both", name: "Both" },
            ]?.map((warehouse: any) => ({
              id: warehouse?.id,
              value: warehouse?.name,
              text: warehouse?.name,
            })) || []
          }
          register={register}
          clearErrors={clearErrors}
          validation={{ required: "Merchant type is required" }}
          error={errors.clientType}
          disabled={!warehouses || warehouses?.warehouses?.length === 0}
          value={watch("clientType")}
          setValue={(val: string) => {
            setValue("clientType", val);
          }}
        />
        <SelectInput
          name="warehouseId"
          className="col-span-2"
          label="Select Warehouse"
          placeholder="Select"
          selectOptions={
            warehouses?.warehouses?.map((warehouse: any) => ({
              id: warehouse?.id,
              value: warehouse?.name,
              text: warehouse?.name,
            })) || []
          }
          register={register}
          clearErrors={clearErrors}
          validation={{ required: "Warehouse is required" }}
          error={errors.warehouseId}
          disabled={!warehouses || warehouses?.warehouses?.length === 0}
          value={watch("warehouseId")}
          setValue={(val: string) => {
            setValue(
              "warehouseId",
              warehouses?.warehouses?.find((e: any) => e?.name === val)?.name
            );
            setValue(
              "city",
              warehouses?.warehouses?.find((e: any) => e?.name === val)
                ?.cityName
            );
            setSelectedData((prev: any) => {
              return {
                ...prev,
                warehouseId: warehouses?.warehouses?.find(
                  (e: any) => e?.name === val
                )?.id,
                city: warehouses?.warehouses?.find((e: any) => e?.name === val)
                  ?.city,
              };
            });
            clearErrors("city");
          }}
        />
        <Input
          labelClass="text-sm text-[#1E293B]"
          name="city"
          type="text"
          title="City"
          placeholder=""
          className="col-span-2"
          register={register}
          error={errors?.city}
          validation={{
            required: "City is required",
          }}
          disabled
        />
        <Input
          labelClass="text-sm text-[#1E293B]"
          name="shippingCost"
          type="number"
          title="Shipping Cost"
          placeholder=""
          register={register}
          className="col-span-6"
          error={errors?.shippingCost}
          validation={{
            required: "Shipping cost is required",
          }}
        />
        <TextArea
          name="address"
          label="Address"
          placeholder=""
          className="col-span-6"
          register={register}
          error={errors?.address}
          validation={{
            required: "Address is required",
            validate: (value: string) => {
              const trimmed = value.trim();
              if (trimmed.length < 10)
                return "Address must be at least 10 characters";
              if (trimmed.length > 300)
                return "Address must be at most 300 characters";
              return true;
            },
          }}
        />
      </div>
    </div>
  );
};

export default AddClientCreateRequestModal;
